export default "assets/images/line-decoration-image-b5893c92.svg";